import { useState } from 'react';

/**
 * 모바일 휴가 신청 페이지의 화면 상태(View)를 관리하는 상수
 *
 * - LIST    : 휴가 신청 목록 화면
 * - DETAIL  : 휴가 신청 상세 화면
 * - REQUEST : 휴가 신청 작성 화면
 *
 * ※ PC 화면과는 무관하며, 모바일 UI 전환 전용 상태값이다.
 */
export const VIEW = {
  LIST: 'LIST',
  DETAIL: 'DETAIL',
  REQUEST: 'REQUEST',
};

export default function useMobileVacationView() {
  /**
   * 현재 모바일 화면 상태
   * 기본값은 휴가 신청 목록 화면
   */
  const [view, setView] = useState(VIEW.LIST);

  return {
    /** 현재 모바일 화면 상태 */
    view,
    /** 휴가 신청 목록 화면으로 이동 */
    openList: () => setView(VIEW.LIST),
    /** 휴가 신청 작성 화면으로 이동 */
    openRequest: () => setView(VIEW.REQUEST),
    /** 휴가 신청 상세 화면으로 이동 */
    openDetail: () => setView(VIEW.DETAIL),
  };
}
